import type { Direction } from "../../../engine/direction";
import { directionDelta } from "../../../engine/direction";
import { Particle } from "../particle";
import { colorConstant, easeOut, lerp, linearMotion, randomBetween } from "../interpolation";

export class AirBlastParticle extends Particle {
	static readonly emitIntervalMs = 100;

	static spawnOffset(direction?: Direction): { x: number; y: number } {
		if (!direction) return { x: 0, y: 0 };
		const delta = directionDelta(direction);
		return { x: delta.x * 0.3, y: delta.y * 0.3 };
	}

	constructor(originX: number, originY: number, direction?: Direction) {
		const delta = direction ? directionDelta(direction) : null;
		const backX = delta ? -delta.x : 0;
		const backY = delta ? -delta.y : 0;
		const mag = Math.sqrt(backX * backX + backY * backY);
		const normX = mag > 0 ? backX / mag : 0;
		const normY = mag > 0 ? backY / mag : 0;

		// Particles drift backward (opposite of travel) with lateral spread
		const speed = randomBetween(2.0, 3.5);
		const lateralSpread = randomBetween(-0.8, 0.8);
		const vx = normX * speed + -normY * lateralSpread;
		const vy = normY * speed + normX * lateralSpread;

		const ox = originX + randomBetween(-0.15, 0.15);
		const oy = originY + randomBetween(-0.15, 0.15);

		const r = randomBetween(220, 255);
		const g = randomBetween(230, 255);
		const b = randomBetween(240, 255);

		super(ox, oy, {
			ttl: randomBetween(250, 300),
			size: lerp(0.4, 0.45),
			opacity: easeOut(0.5, 0.3),
			color: colorConstant(r, g, b),
			rotation: lerp(0, randomBetween(-1, 1)),
			position: linearMotion(vx, vy),
		});
	}
}
